export default "__VITE_ASSET__fe799d08__"